// A cell which displays date time values in the current time zone.
import React from 'react';
import moment from 'moment';

export default function(value) {
    let displayValue = moment(value).format('YYYY-MM-DD');
    if (displayValue === 'Invalid date') {
        displayValue = '-';
    }
    return <div className="cell">{displayValue}</div>;
}



// WEBPACK FOOTER //
// ./src/view/common/table/formatters/DateTimeCell.jsx